const convertToString = (input) => {
	if (input) {
		if (typeof input === "string") {
			return input;
		}
		return String(input);
	}
	return "";
};

// convert string to words
const toWords = (input) => {
	input = convertToString(input);
	const regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
	return input.match(regex) || [];
};

export const toCamelCase = (value) => {
	const inputArray = toWords(value);
	return inputArray.map((word, index) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1))).join("");
};
